import React, { useState } from 'react'
import { Modal, Tooltip } from 'antd'
import { Button, MasterDetailForm, Widget, notification } from '@digital/ui'
import { activeStepHashState, reloadState, solicitacaoIdState } from '../atoms';
import { useRecoilState, useRecoilValue } from 'recoil';
import { validarSolicitacaoNaoPrevisto } from '@app/api/naoPrevistos/solicitacao';
import '../custom.css'
import { EStepsSolicitacaoNaoPrevisto } from '@app/enums/ENaoPrevisto';

const ModalAprovarSolicitacao = ({ disabled }: any) => {
    const [reload, setReload] = useRecoilState(reloadState);
    const idSolicitacao = useRecoilValue(solicitacaoIdState);
    const [exibirModal, setExibirModal] = useState(false)
    const step = useRecoilValue(activeStepHashState);

    const title = step === EStepsSolicitacaoNaoPrevisto.ValidacaoAdministrador ||
        step === EStepsSolicitacaoNaoPrevisto.ValidacaoGDGPP ||
        step === EStepsSolicitacaoNaoPrevisto.ValidacaoGerenciaGFG ? 'Validar' : 'Aprovar'

    const onValidarSolicitacao = (validacao: boolean, justificativa?: string) => {
        if (idSolicitacao) {
            validarSolicitacaoNaoPrevisto(idSolicitacao, validacao, justificativa).then((result) => {
                setExibirModal(false);
                if (result) {
                    setReload(!reload);
                }
            })
        }
    }

    return (
        <>
            <Tooltip title={title}>
                <Button
                    id='mrn-button-stepv2-approve'
                    type='success'
                    title={title}
                    onClick={() => {
                        setExibirModal(true)
                    }}
                    disabled={disabled}
                />
            </Tooltip>

            <Modal
                title={`${title} Solicitação`}
                visible={exibirModal}
                onCancel={() => setExibirModal(false)}
                footer={[
                    <Button
                        type='link'
                        title='Fechar'
                        onClick={() => setExibirModal(false)}
                    />,
                    <Button
                        id='mrn-button-stepv2-approve'
                        type='success'
                        title={title}
                        onClick={() => onValidarSolicitacao(true)}
                    />
                ]}
            >
                <MasterDetailForm>
                    <Widget>
                        <span>Tem certeza que deseja {title.toLowerCase()} a solicitação?</span>
                    </Widget>
                </MasterDetailForm>
            </Modal>
        </>
    )
}

export default ModalAprovarSolicitacao